import {
  APPLICANT_DETAILS_SUBMIT,
  LOAD_MOBILE_VALIDATIONS,
  UPDATE_MOBILE_NUMBER
} from '../../action-contants';
import { API_URL, API_URL_V2, API_URL_V3 } from '../../../utils/config';
import { networkCall, getUniqueSessionId } from '../../../utils/library';
import { handleError, showMessage } from '../common-message/message-action';
import { remitterPersonalInfo } from '../user-status/user-status-action';
import { INDIVIDUAL } from '../../../utils/constants';
import { getBatchNumber } from '../../../utils/multiple-transactions/multiple-transactions';
import { makeApiCall } from '../common/common-action';

export function UpdateMobileNumber(data) {
  return {
    type: UPDATE_MOBILE_NUMBER,
    data
  };
}

export function loadMobileValidation(data) {
  return {
    type: LOAD_MOBILE_VALIDATIONS,
    data
  };
}

export function applicantDetailsSubmit(data) {
  return {
    type: APPLICANT_DETAILS_SUBMIT,
    data
  };
}

export function sendOtpOnMobile(data) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/send-mobile-otp`,
        withCredentials: true,
        data: data
      });
      dispatch(UpdateMobileNumber(data.mobile_number));
      return response;
    } catch (error) {
      dispatch(handleError(error));
      let { response } = error;
      return response;
    }
  };
}

export function verifyMobileOtp(
  otp,
  mobile_number,
  mobile_country_code,
  country_of_residence,
  dataLayerObj
) {
  return async (dispatch) => {
    try {
      let postdata = {
        otp,
        mobile_number,
        mobile_country_code,
        country_of_residence,
        session_id: getUniqueSessionId()
      };
      let params = {
        method: 'patch',
        url: `${API_URL}/remitter/verify-mobile-otp`,
        withCredentials: true,
        data: postdata
      };
      let response = await networkCall(params, dispatch, postdata, dataLayerObj);
      dispatch(remitterPersonalInfo());
      if (response && response.data && response.data.success && response.data.data) {
        if (response.data.data.remitter_corporate_representative_id) {
          let remitter_corporate_representative_id =
            response.data.data.remitter_corporate_representative_id;
          dispatch(applicantDetailsSubmit({ remitter_corporate_representative_id }));
        }
        return response.data.success;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return false;
  };
}

export function verifyTransactionMobileOtp(otp, account_type) {
  return async (dispatch, getState) => {
    try {
      let url = `${API_URL}`;
      if (account_type === INDIVIDUAL) {
        let transaction = getState().rootReducer.transactionReducer.transactionDetails;
        url += `/transaction/${transaction.temp_transaction_id}/verifyotp`;
      } else {
        let recipientList =
            getState().rootReducer.transactionReducer.multipleTransactions.recipientList,
          batch_number = getBatchNumber(recipientList);
        if (batch_number) url += `/batch/${batch_number}/verifyotp`;
      }
      let response = await makeApiCall({
        url,
        method: 'post',
        withCredentials: true,
        data: {
          otp,
          session_id: getUniqueSessionId()
        }
      });

      await dispatch(remitterPersonalInfo());
      if (response && response.data) {
        return response.data.success;
      }
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
    return false;
  };
}

export function sendTransactionMobileOtp(is_send_otp, account_type) {
  return async (dispatch, getState) => {
    try {
      let url = `${API_URL}`,
        method = 'get';
      if (account_type === INDIVIDUAL) {
        let transaction = getState().rootReducer.transactionReducer.transactionDetails;
        url += `/transaction/${transaction.temp_transaction_id}/sendotp`;
      } else {
        let recipientList =
            getState().rootReducer.transactionReducer.multipleTransactions.recipientList,
          batch_number = getBatchNumber(recipientList);
        method = 'post';
        if (batch_number) url += `/batch/${batch_number}/sendotp`;
      }
      return await makeApiCall({
        url,
        method,
        withCredentials: true,
        params: {
          is_send_otp
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function verifyOtpEuRegion(data, twoFactorToken) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: twoFactorToken ? `${API_URL_V2}/verify-otp` : `${API_URL}/user/verifyotp`,
        withCredentials: true,
        data: {
          ...data,
          session_id: getUniqueSessionId()
        }
      });
      if (response && response.data) return response.data.success;
    } catch (error) {
      dispatch(handleError(error));
    }
    return false;
  };
}

export function sendOtpEuRegion(data, twoFactorToken) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'post',
        url: twoFactorToken ? `${API_URL}/send-otp` : `${API_URL}/user/sendotp`,
        withCredentials: true,
        data: {
          ...data
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function sendEmailOtp(data) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/signup/send/otp`,
        data: {
          type: 'EMAIL',
          email: data.email,
          token: data.emailVerificationToken
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export const verifyEmailOtp = (data) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/signup/verify/otp`,
        data: {
          type: 'EMAIL',
          email: data.email,
          token: data.emailVerificationToken,
          otp: data.otp,
          ...(data?.auth_type ? { auth_type: data.auth_type } : {})
        }
      });
      if (response?.data) return response;
    } catch (error) {
      dispatch(handleError(error));
    }
    return false;
  };
};

export function getPhoneValidationsByCountry(countryCode, isSignUpView) {
  return async (dispatch) => {
    if (!countryCode) return null;
    try {
      let url = isSignUpView
        ? `${API_URL}/public/validation/phone?country_code=${countryCode}`
        : `${API_URL}/validation/phone?country_code=${countryCode}`;
      let response = await makeApiCall({
        url,
        method: 'get',
        withCredentials: true
      });
      if (!response) throw new Error('no response');
      if (response && response.data && response.data.data) {
        dispatch(loadMobileValidation(response.data.data[0].phone_number_validation));
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function sendOTPAuRevamped(data) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/mobile/otp/send`,
        data,
        withCredentials: true
      });
      return { success: true, ...response?.data?.data };
    } catch (e) {
      dispatch(handleError(e));
    }
    return { success: false };
  };
}

export function verifyOTPAuRevamp(data) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/mobile/otp/verify`,
        data,
        withCredentials: true
      });
      return { success: true, ...response?.data?.data };
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}
